import React, { Component }   from 'react';
import {connect}            from 'react-redux';
import {Modal}              from 'react-bootstrap';
import {SetLikePostUser,
        GetTipoMidiaPost,
        GetQtdCommentPostTurma,
        GetRemoverPostTurma,
        GetRegistroPostTurma } from '../../../actions/turmaAction';
import TurmaPostComentario     from './turma_post_comentario';
import BtAcaoComentario        from '../../../container/btAcaoRemoverItem';
import BtLikePost              from '../../../container/bt_like_timeline_turma';
import BtComentarioNave        from '../../../container/bt_comentario_timeline_turma';
import TimeLineItem            from '../../../container/renderTimeLineEquipe';
import FlashRetornoNulo        from '../../../container/FlashRetornoNulo';

class Turma_Post_Item extends Component {

    constructor(props){

        super(props);
        this.state = {
                        like             : "#AAB8BE",
                        ItemPostTimeline : [],
                        showModal        : false,
                        load             : false,
                        tur_id           : ( this.props.session.turma ?  this.props.session.turma : this.props.tur_id)
                      }
                    
    }

    close(){
      this.setState({showModal: false,ItemPostTimeline:[]});
    }

    open(val) {
     
       this.setState({  
          showModal        : true,
          ItemPostTimeline : this.props.allPostsTurma[val],
          vetor            : val
        });
    }

    excluirPostTurma(id){

        const acao  = window.confirm("Deseja Remover?");
        if (acao) {
            this.props.GetRemoverPostTurma(this.props.session.id,id);
        }
    }  

    likePost(val){
       // Função que adiciona like do post da nave 
       this.props.SetLikePostUser(val,this.props.session.id);
    } 

    renderListItemPosts(){
         // Função que lista todos os posts da nave
         const retornoListaItem = this.props.allPostsTurma;
     
         if (retornoListaItem.length>0) {

                return retornoListaItem.map((elem,i)=>{

                    //Componente gerador botao de like    
                    const btLike       = <BtLikePost vetor={i} funcao={this.likePost.bind(this,elem.tur_pos_id)}/>;
                     //Componente gerador botao de comentario
                    const btComentario = <BtComentarioNave vetor={i} funcao={this.open.bind(this,i)}/>;
                    const btAcao       = <span>{btLike} {btComentario}</span>;

                    return  <TimeLineItem
                                key          = {i}
                                id           = {elem.tur_pos_id}
                                foto         = {elem.use_foto}
                                nome         = {elem.use_nome}
                                btAcao       = {elem.tur_pos_cod_usuario === this.props.session.id ? <BtAcaoComentario funcao={this.excluirPostTurma.bind(this,elem.tur_pos_id)}/> : ""}
                                dataCriado   = {elem.created_at}
                                postConteudo = {elem.tur_pos_post}
                                midia        = {elem.tur_pos_midia}
                                tipo         = {elem.tur_pos_tipo}
                                postMidia    = {<div dangerouslySetInnerHTML={{__html: this.props.GetTipoMidiaPost(elem)}} />}
                                footerPost   = { btAcao }
                                />  
                });

                }else{
                    return <FlashRetornoNulo text="Seja o primeira a publicar na nave."/>
                }
    }

    render () {

        return (<div>
                 <ul className="timeline">
                   { this.renderListItemPosts()}
                 </ul>
                   <Modal show={this.state.showModal} onHide={this.close.bind(this)}>
                   <Modal.Header closeButton>
                     
                    </Modal.Header>
                      <TurmaPostComentario tur_id={this.state.tur_id} ItemPostTimeline={this.state.ItemPostTimeline}/> 
                    </Modal>
                </div>);
    }
}

function  mapStateToProps(state){

    return {
             session       : state.auth.session,
             allPostsTurma : state.turmaReducer.all_posts,
             all_likes     : state.turmaReducer.all_likes,
             feth_tur_id   : state.turmaReducer.fetch_tur_id
    }
}

export default connect(mapStateToProps,{SetLikePostUser,GetTipoMidiaPost,GetQtdCommentPostTurma,GetRemoverPostTurma,GetRegistroPostTurma})(Turma_Post_Item);




// WEBPACK FOOTER //
// ./src/components/professor/timeline_turma/turma_post_item.js